import { create } from "zustand";

interface PendingEntity {
  id: string;
  type: string;
}

interface CurrentConversationState {
  currentConversation: string | null;
  setCurrentConversation: (conversationId: string | null) => void;

  currentTeenId: string | null;
  setCurrentTeenId: (teenId: string) => void;

  pendingEntity: PendingEntity | null;
  setPendingEntity: (entity: PendingEntity | null) => void;
}

export const useCurrentConversation = create<CurrentConversationState>(
  (set) => ({
    currentConversation: null,
    setCurrentConversation: (conversationId) => {
      set({ currentConversation: conversationId });
    },

    currentTeenId: null,
    setCurrentTeenId: (teenId) => set({ currentTeenId: teenId }),

    pendingEntity: null,
    setPendingEntity: (entity) => set({ pendingEntity: entity }),
  }),
);
